import React from "react";
import "primeflex/primeflex.css"; // Ensure you have this import

const Footer: React.FC = () => {
  return (
    <footer className="footer bg-black-alpha-10 mt-2">
      <div className="grid align-items-center">
        <div className="col-12 md:col-4 text-center md:text-left">
          <img
            alt="logo"
            src="Acreditacion_color.png"
            height="80"
            className="mr-2"
          />
        </div>
        <div className="col-12 md:col-4 text-center">
          <span id="contacto">
            Desarrollado por la Dirección de Informática
          </span>
        </div>
        <div className="col-12 md:col-4 text-center md:text-right pr-5">
          <span>Universidad de Antofagasta ©</span>
          <br />
          <span>Avenida Angamos 601</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
